import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=37b56349&scoped=true"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=37b56349&prod&lang=css"
import style1 from "./AppSettings.vue?vue&type=style&index=1&id=37b56349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b56349",
  null
  
)

export default component.exports